import RentApartmentsListItem from './RentApartments';
import RentCommercialsListItem from './RentCommercials';
import RentDailyApartmentsListItem from './RentDailyApartments';
import SaleApartmentsListItem from './SaleApartments';
import SaleCommercialsListItem from './SaleCommercials';
import SaleGaragesListItem from './SaleGarages';
import SaleLandsListItem from './SaleLands';

module.exports = {
  RentApartmentsListItem,
  RentCommercialsListItem,
  RentDailyApartmentsListItem,
  SaleApartmentsListItem,
  SaleCommercialsListItem,
  SaleGaragesListItem,
  SaleLandsListItem
};



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/ListItems/index.js